module.exports = __webpack_public_path__ + "assets/icon-check.f62a7fc7.png";